import { render, staticRenderFns } from "./UserArticleReview.vue?vue&type=template&id=a1f2dfe0&"
import script from "./UserArticleReview.vue?vue&type=script&lang=js&"
export * from "./UserArticleReview.vue?vue&type=script&lang=js&"
import style0 from "./UserArticleReview.vue?vue&type=style&index=0&scrop=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports